<template>
  <tr>
    <td>
      <router-link v-if="!$route  .query.referrer" :to="{name: 'AdminGiro', query: {referrer: d.id, group: 5}}">
        {{ d.fullName }}
      </router-link>

      <span v-if="$route.query.referrer">
        {{ d.fullName }}
      </span>
    </td>
    <td>
      <router-link :to="{query: {casino_report: d.id}}">
        <span class="amount">
          {{  balance.casino_profit | toMoney(balance.currency) }}
        </span>
      </router-link>
    </td>
    <td>
      <span class="amount">
        {{  balance.bet_profit | toMoney(balance.currency)  }}
      </span>
    </td>
    <td>
      <span class="amount">
        {{  (Number(balance.bet_profit) + Number(balance.casino_profit)) | toMoney(balance.currency) }}
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: "AdminGiroRow",
  props: ['d', 'start', 'end'],
  data() {
    return {
      session: window.session,
      balance: {},
    }
  },
  watch: {
    'start' () {
      this.fetchBalance();
    },
    'end' () {
      this.fetchBalance();
    },
  },
  mounted () {
    this.fetchBalance();
  },
  methods: {
    fetchBalance(){

      if(this.end){
        this.$http.get(api + 'api/v1/reseller_giro/'+this.d.id, {
            params: {
              start: this.start,
              end: this.end
            }
          })
          .then(response => {
            this.balance = response.body.result.data;


            this.$parent.totalBetProfit += this.balance.bet_profit;
            this.$parent.totalCasinoProfit += this.balance.casino_profit;
            this.$parent.total += parseFloat(this.balance.bet_profit);
            this.$parent.total += parseFloat(this.balance.casino_profit);

          }, response => {

          })
      }

    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/row/AdminGiroRow.vue